import React from "react";
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import Select from "react-select";
import SelectDateRangeDropdown from "./SelectDateRangeDropdown";
import { ControlledInput } from "../../common/Input/Input";
export default function PackageCatalogueTable(props)
{
    const columns = [
		{
			id: "sPackageOfferTitle",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Package/Offering Title",
			accessor: "sPackageOfferTitle",
			width: 290,
		},
		{
			id: "sType",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Offering Type",
			accessor: "sType",
			width: 200,
		},
		{
			id: "sPackageOfferPaymentType",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Payment Type",
			accessor: "sPackageOfferPaymentType",
			width: 130,
        },
        {
			id: "fPackageOfferTotalCost",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Package/Offering Total Cost (Incl. GST)",
			accessor: "fPackageOfferTotalCost",
			width: 170,
			//Cell: ({ original }) => (parseFloat(original.fPackageOfferTotalCost)>0 ? <>{original.fPackageOfferTotalCost} {" (Incl. GST)"} </>  : original.fPackageOfferTotalCost),
		},
        {
			id: "dtStartDate",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Start Date",
			accessor: "dtStartDate",
			width: 120,
			Cell: ({ original }) =>
				moment(original.dtStartDate).format("DD/MM/YYYY"),
        },
        {
			id: "dtEndDate",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "End Date",
			accessor: "dtEndDate",
			width: 130,
			Cell: ({ original }) =>
				moment(original.dtEndDate).format("DD/MM/YYYY"),
		},
		{
			id: "sPackageOfferDelivery",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Delivery Type",
			accessor: "sPackageOfferDelivery",
			Cell: ({ original }) => (original.sPackageOfferDelivery ? original.sPackageOfferDelivery : "NA"),
			width: 160,
        },
        {
			id: "sPackageOfferStatus",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Status",
			accessor: "sPackageOfferStatus",
			width: 110,
        },
        {
			id: "bIsActive",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Is Active",
			accessor: "bIsActive",
			Cell: ({ original }) => (original.bIsActive ? "Yes" : "No"),
			width: 90,
        },
        {
			id: "sCreatedBy",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Created By",
			accessor: "sCreatedBy",
			width: 250,
        },
        {
			id: "dtCreated",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Created On",
			accessor: "dtCreated",
			width: 120,
			Cell: ({ original }) =>
				moment(original.dtCreated).format("DD/MM/YYYY"),
		},
        {
			id: "sUpdatedBy",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Updated By",
			accessor: "sUpdatedBy",
			width: 240,
        },
        {
			id: "dtUpdated",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Updated On",
			accessor: "dtUpdated",
			width: 100,
			Cell: ({ original }) =>
				moment(original.dtUpdated).format("DD/MM/YYYY"),
			width: 120,
		},
		{
			id: "id",
			headerStyle:{'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			style: { 'whiteSpace': 'pre-wrap', overflowWrap: 'break-word'},
			Header: "Action",
			accessor: "id",
			Cell: ({ original }) =>
			(
				<>
					<button className="btn r-button primary" style={{marginRight:"10px",width:"150px"}} onClick={(f) =>props.onPackageServicesClicked(original)}>
					{original.sType===''||original.sType==="Package"?
						"Service Mapping":
					"Resource Mapping"}
					</button>
					{
						original.bIsActive?original.sPackageOfferStatus==="Draft"?
						(
							<button className="btn r-button primary" style={{marginRight:"10px"}} onClick={(f) =>props.onEditPackagClicked(original)}>
								Edit
							</button>
						)
						:
						(
							<button className="btn r-button primary disabled" style={{marginRight:"10px"}}>
								Edit
							</button>
						):
						(
							<button className="btn r-button primary disabled" style={{marginRight:"10px"}}>
								Edit
							</button>
						)
					}
					{
						original.bIsActive?
						(
							<button className="btn r-button primary" onClick={(f) =>props.onDeactivatePackagClicked(original)}>
								Deactivate
							</button>
						)
						:
						(
							<button className="btn r-button primary disabled">
								Deactivate
							</button>
						)
					}
				</>
			),
			width: 340,
		},
    ];
    
    return (
        <div className={`row row-container ${props.isLoading && "set-opacity"}`} >
			{props.isLoading && <Spinner className="center-screen" />}
			<div className="col-12">
				<label>
					<b>Package/Offering Catalogues</b>
				</label>
			</div>
			<div className="col-md-12 inline-margin-packageview" style={{marginTop:"5px"}}>
					<label>
						<b>Filter and search</b>
					</label>
					<div style={{clear:"both"}}></div>

					<ControlledInput
						placeholder="Search Package/Offering Title..."
						onChange={props.onSearchInputChange}
						onKeyPress={(e) => {
							if (e.key === "Enter") {
								props.onSearchClicked();
							}
						}}
						value={props.searchTerm}
					/>
					<SelectDateRangeDropdown
						dateFrom={props.selectedStartDateFrom}
						setDateFrom={props.setselectedStartDateFrom}
						placeholderTextfrom={"Start Date"}
						dateTo={props.selectedStartDateTo}
						setDateTo={props.setselectedStartDateTo}
						placeholderTextTo={"End Date"}
					/>	
					<Select
						options={props.PackageTypesOptions}
						onChange={props.onPackageTypeChange}
						value={props.selectedPackageTypeForFilter}
						isClearable
						placeholder={"Select Payment Type"}
					/>
					
								
				</div>
			<div className="col-12 inline-margin-packageview row-margin-10px" style={{marginTop:"10px"}}>
					<Select
						options={props.PackageStatusOptions}
						onChange={props.onPackageStatusChange}
						value={props.selectedPackageStatusForFilter}
						isClearable
						placeholder={"Select Status"}
					/>
					<Select
						options={props.packageDeliveryOptions}
						onChange={props.onPackageDeliveryChange}
						value={props.selectedPackageDeliveryOptionForFilter}
						isClearable
						placeholder={"Select Delivery Type"}
					/>	

					<Select
						options={props.packageActiveStatusOptions}
						onChange={props.onPackageActiveStatusOptionChange}
						value={props.selectedPackageActiveStatusOptionForFilter}
						isClearable
						placeholder={"Select Is Active"}
					/>
				<Button className="inline-button" onClick={props.onSearchClicked}>Search</Button>
				<Button className="inline-button" onClick={props.onClearFilterSearch}>Clear</Button>				

				<div className="float-right">
					<Button className="inline-button" style={{marginRight:"0px"}} onClick={props.onCreatePackageClick}>
						Create Package/Offering
					</Button>
				</div>
			</div>
            <div className="col-12">
                <ReactTable
                    data={props.data || []}
                    columns={columns}
					manual
					sortable={false}
                    showPagination={false}
                    style={{overflowY: "auto",height: "425px"}}			
                    NextComponent={(instance) => (
                        <Button className="mt3" {...instance}>
                            Next
                        </Button>
                    )}
                    PreviousComponent={(instance) => (
                        <Button className="mt3" {...instance}>
                            Previous
                        </Button>
                    )}
                />
            </div>
        </div>
		
	);
}